import * as actionTypes from "./CategoryType";

const INITIAL_STATE = {
    categoryList: [],
    accountList: [],
    sacList: []
};

const CategoryReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETCATEGORY:
            return {
                ...state,
                categoryList: action.payload.list,
            };
        case actionTypes.SETACCOUNT:
            return {
                ...state,
                accountList: action.payload.list,
            };
        case actionTypes.SETSAC:
            return {
                ...state,
                sacList: action.payload.list,
            };
        default:
            return state;
    }
}

export default CategoryReducer;